module.exports = __webpack_public_path__ + "media/v2/components/Contests/shared/Image/mob-m-player-row-e5e191e1b550aa5b626bfa97236c8ff8.svg";